import { QueryKey } from '@tanstack/react-query';

export interface FeatureQueryKeys {
  all: QueryKey;
  list: (params?: unknown) => QueryKey;
  detail: (id: string) => QueryKey;
  sub: (...segments: unknown[]) => QueryKey;
}

export function createQueryKeys(root: string): FeatureQueryKeys {
  return {
    all: [root],
    list: (params) => (params === undefined ? [root, 'list'] : [root, 'list', params]),
    detail: (id) => [root, 'detail', id],
    sub: (...segments) => [root, ...segments],
  };
}
